/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Divider,
  Flex,
  Grid,
  Heading,
  SelectField,
  Text,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
import { EmissionAccountEntry } from "../models";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { DataStore } from "aws-amplify/datastore";
export default function EmissionAccountEntryUpdateForm(props) {
  const {
    id: idProp,
    emissionAccountEntry: emissionAccountEntryModelProp,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    EmissionScope: "",
    EmissionCategory: "",
    EmissionDescription: "",
    DataSource: "",
    EmissionDate: "",
    EmissionUnit: "",
    EmissionUsageValue: "",
    EmissionConversionFactor: "",
    GrossEmission: "",
    EmissionDateRangeStart: "",
    EmissionDateRangeEnd: "",
  };
  const [EmissionScope, setEmissionScope] = React.useState(
    initialValues.EmissionScope
  );
  const [EmissionCategory, setEmissionCategory] = React.useState(
    initialValues.EmissionCategory
  );
  const [EmissionDescription, setEmissionDescription] = React.useState(
    initialValues.EmissionDescription
  );
  const [DataSource, setDataSource] = React.useState(initialValues.DataSource);
  const [EmissionDate, setEmissionDate] = React.useState(
    initialValues.EmissionDate
  );
  const [EmissionUnit, setEmissionUnit] = React.useState(
    initialValues.EmissionUnit
  );
  const [EmissionUsageValue, setEmissionUsageValue] = React.useState(
    initialValues.EmissionUsageValue
  );
  const [EmissionConversionFactor, setEmissionConversionFactor] =
    React.useState(initialValues.EmissionConversionFactor);
  const [GrossEmission, setGrossEmission] = React.useState(
    initialValues.GrossEmission
  );
  const [EmissionDateRangeStart, setEmissionDateRangeStart] = React.useState(
    initialValues.EmissionDateRangeStart
  );
  const [EmissionDateRangeEnd, setEmissionDateRangeEnd] = React.useState(
    initialValues.EmissionDateRangeEnd
  );
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    const cleanValues = emissionAccountEntryRecord
      ? { ...initialValues, ...emissionAccountEntryRecord }
      : initialValues;
    setEmissionScope(cleanValues.EmissionScope);
    setEmissionCategory(cleanValues.EmissionCategory);
    setEmissionDescription(cleanValues.EmissionDescription);
    setDataSource(cleanValues.DataSource);
    setEmissionDate(cleanValues.EmissionDate);
    setEmissionUnit(cleanValues.EmissionUnit);
    setEmissionUsageValue(cleanValues.EmissionUsageValue);
    setEmissionConversionFactor(cleanValues.EmissionConversionFactor);
    setGrossEmission(cleanValues.GrossEmission);
    setEmissionDateRangeStart(cleanValues.EmissionDateRangeStart);
    setEmissionDateRangeEnd(cleanValues.EmissionDateRangeEnd);
    setErrors({});
  };
  const [emissionAccountEntryRecord, setEmissionAccountEntryRecord] =
    React.useState(emissionAccountEntryModelProp);
  React.useEffect(() => {
    const queryData = async () => {
      const record = idProp
        ? await DataStore.query(EmissionAccountEntry, idProp)
        : emissionAccountEntryModelProp;
      setEmissionAccountEntryRecord(record);
    };
    queryData();
  }, [idProp, emissionAccountEntryModelProp]);
  React.useEffect(resetStateValues, [emissionAccountEntryRecord]);
  const validations = {
    EmissionScope: [],
    EmissionCategory: [],
    EmissionDescription: [],
    DataSource: [],
    EmissionDate: [],
    EmissionUnit: [],
    EmissionUsageValue: [],
    EmissionConversionFactor: [],
    GrossEmission: [],
    EmissionDateRangeStart: [],
    EmissionDateRangeEnd: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          EmissionScope,
          EmissionCategory,
          EmissionDescription,
          DataSource,
          EmissionDate,
          EmissionUnit,
          EmissionUsageValue,
          EmissionConversionFactor,
          GrossEmission,
          EmissionDateRangeStart,
          EmissionDateRangeEnd,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await DataStore.save(
            EmissionAccountEntry.copyOf(
              emissionAccountEntryRecord,
              (updated) => {
                Object.assign(updated, modelFields);
              }
            )
          );
          if (onSuccess) {
            onSuccess(modelFields);
          }
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(overrides, "EmissionAccountEntryUpdateForm")}
      {...rest}
    >
      <Heading
        level={4}
        children="Greenhouse Gas Emission Transaction"
        {...getOverrideProps(overrides, "SectionalElement0")}
      ></Heading>
      <Text
        children="Update this record of a Greenhouse Gas emission transaction you are responsible for."
        {...getOverrideProps(overrides, "SectionalElement1")}
      ></Text>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement2")}
      ></Divider>
      <Grid
        columnGap="inherit"
        rowGap="inherit"
        templateColumns="repeat(2, auto)"
        {...getOverrideProps(overrides, "RowGrid3")}
      >
        <SelectField
          label="Emission scope"
          placeholder="Please select an option"
          isDisabled={false}
          value={EmissionScope}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                EmissionScope: value,
                EmissionCategory,
                EmissionDescription,
                DataSource,
                EmissionDate,
                EmissionUnit,
                EmissionUsageValue,
                EmissionConversionFactor,
                GrossEmission,
                EmissionDateRangeStart,
                EmissionDateRangeEnd,
              };
              const result = onChange(modelFields);
              value = result?.EmissionScope ?? value;
            }
            if (errors.EmissionScope?.hasError) {
              runValidationTasks("EmissionScope", value);
            }
            setEmissionScope(value);
          }}
          onBlur={() => runValidationTasks("EmissionScope", EmissionScope)}
          errorMessage={errors.EmissionScope?.errorMessage}
          hasError={errors.EmissionScope?.hasError}
          {...getOverrideProps(overrides, "EmissionScope")}
        >
          <option
            children="Scope 1"
            value="Scope_1"
            {...getOverrideProps(overrides, "EmissionScopeoption0")}
          ></option>
          <option
            children="Scope 2"
            value="Scope_2"
            {...getOverrideProps(overrides, "EmissionScopeoption1")}
          ></option>
          <option
            children="Scope 3"
            value="Scope_3"
            {...getOverrideProps(overrides, "EmissionScopeoption2")}
          ></option>
        </SelectField>
        <SelectField
          label="Emission category"
          placeholder="Please select an option"
          isDisabled={false}
          value={EmissionCategory}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                EmissionScope,
                EmissionCategory: value,
                EmissionDescription,
                DataSource,
                EmissionDate,
                EmissionUnit,
                EmissionUsageValue,
                EmissionConversionFactor,
                GrossEmission,
                EmissionDateRangeStart,
                EmissionDateRangeEnd,
              };
              const result = onChange(modelFields);
              value = result?.EmissionCategory ?? value;
            }
            if (errors.EmissionCategory?.hasError) {
              runValidationTasks("EmissionCategory", value);
            }
            setEmissionCategory(value);
          }}
          onBlur={() =>
            runValidationTasks("EmissionCategory", EmissionCategory)
          }
          errorMessage={errors.EmissionCategory?.errorMessage}
          hasError={errors.EmissionCategory?.hasError}
          {...getOverrideProps(overrides, "EmissionCategory")}
        >
          <option
            children="Category 1"
            value="Category_1"
            {...getOverrideProps(overrides, "EmissionCategoryoption0")}
          ></option>
          <option
            children="Category 2"
            value="Category_2"
            {...getOverrideProps(overrides, "EmissionCategoryoption1")}
          ></option>
          <option
            children="Category 3"
            value="Category_3"
            {...getOverrideProps(overrides, "EmissionCategoryoption2")}
          ></option>
          <option
            children="Category 4"
            value="Category_4"
            {...getOverrideProps(overrides, "EmissionCategoryoption3")}
          ></option>
          <option
            children="Category 5"
            value="Category_5"
            {...getOverrideProps(overrides, "EmissionCategoryoption4")}
          ></option>
          <option
            children="Category 6"
            value="Category_6"
            {...getOverrideProps(overrides, "EmissionCategoryoption5")}
          ></option>
        </SelectField>
      </Grid>
      <TextAreaField
        label="Emission description"
        isRequired={false}
        isReadOnly={false}
        value={EmissionDescription}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              EmissionScope,
              EmissionCategory,
              EmissionDescription: value,
              DataSource,
              EmissionDate,
              EmissionUnit,
              EmissionUsageValue,
              EmissionConversionFactor,
              GrossEmission,
              EmissionDateRangeStart,
              EmissionDateRangeEnd,
            };
            const result = onChange(modelFields);
            value = result?.EmissionDescription ?? value;
          }
          if (errors.EmissionDescription?.hasError) {
            runValidationTasks("EmissionDescription", value);
          }
          setEmissionDescription(value);
        }}
        onBlur={() =>
          runValidationTasks("EmissionDescription", EmissionDescription)
        }
        errorMessage={errors.EmissionDescription?.errorMessage}
        hasError={errors.EmissionDescription?.hasError}
        {...getOverrideProps(overrides, "EmissionDescription")}
      ></TextAreaField>
      <Grid
        columnGap="inherit"
        rowGap="inherit"
        templateColumns="repeat(2, auto)"
        {...getOverrideProps(overrides, "RowGrid5")}
      >
        <TextField
          label="Data source"
          isRequired={false}
          isReadOnly={false}
          value={DataSource}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                EmissionScope,
                EmissionCategory,
                EmissionDescription,
                DataSource: value,
                EmissionDate,
                EmissionUnit,
                EmissionUsageValue,
                EmissionConversionFactor,
                GrossEmission,
                EmissionDateRangeStart,
                EmissionDateRangeEnd,
              };
              const result = onChange(modelFields);
              value = result?.DataSource ?? value;
            }
            if (errors.DataSource?.hasError) {
              runValidationTasks("DataSource", value);
            }
            setDataSource(value);
          }}
          onBlur={() => runValidationTasks("DataSource", DataSource)}
          errorMessage={errors.DataSource?.errorMessage}
          hasError={errors.DataSource?.hasError}
          {...getOverrideProps(overrides, "DataSource")}
        ></TextField>
        <TextField
          label="Emission date"
          isRequired={false}
          isReadOnly={false}
          type="date"
          value={EmissionDate}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                EmissionScope,
                EmissionCategory,
                EmissionDescription,
                DataSource,
                EmissionDate: value,
                EmissionUnit,
                EmissionUsageValue,
                EmissionConversionFactor,
                GrossEmission,
                EmissionDateRangeStart,
                EmissionDateRangeEnd,
              };
              const result = onChange(modelFields);
              value = result?.EmissionDate ?? value;
            }
            if (errors.EmissionDate?.hasError) {
              runValidationTasks("EmissionDate", value);
            }
            setEmissionDate(value);
          }}
          onBlur={() => runValidationTasks("EmissionDate", EmissionDate)}
          errorMessage={errors.EmissionDate?.errorMessage}
          hasError={errors.EmissionDate?.hasError}
          {...getOverrideProps(overrides, "EmissionDate")}
        ></TextField>
      </Grid>
      <Grid
        columnGap="inherit"
        rowGap="inherit"
        templateColumns="repeat(2, auto)"
        {...getOverrideProps(overrides, "RowGrid6")}
      >
        <SelectField
          label="Emission unit (e.g. litres)"
          placeholder="Please select an option"
          isDisabled={false}
          value={EmissionUnit}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                EmissionScope,
                EmissionCategory,
                EmissionDescription,
                DataSource,
                EmissionDate,
                EmissionUnit: value,
                EmissionUsageValue,
                EmissionConversionFactor,
                GrossEmission,
                EmissionDateRangeStart,
                EmissionDateRangeEnd,
              };
              const result = onChange(modelFields);
              value = result?.EmissionUnit ?? value;
            }
            if (errors.EmissionUnit?.hasError) {
              runValidationTasks("EmissionUnit", value);
            }
            setEmissionUnit(value);
          }}
          onBlur={() => runValidationTasks("EmissionUnit", EmissionUnit)}
          errorMessage={errors.EmissionUnit?.errorMessage}
          hasError={errors.EmissionUnit?.hasError}
          {...getOverrideProps(overrides, "EmissionUnit")}
        >
          <option
            children="Employees"
            value="Employees"
            {...getOverrideProps(overrides, "EmissionUnitoption0")}
          ></option>
          <option
            children="Kg"
            value="Kg"
            {...getOverrideProps(overrides, "EmissionUnitoption1")}
          ></option>
          <option
            children="Kw"
            value="Kw"
            {...getOverrideProps(overrides, "EmissionUnitoption2")}
          ></option>
          <option
            children="Kwh"
            value="Kwh"
            {...getOverrideProps(overrides, "EmissionUnitoption3")}
          ></option>
          <option
            children="Litres"
            value="Litres"
            {...getOverrideProps(overrides, "EmissionUnitoption4")}
          ></option>
          <option
            children="Metres cubed"
            value="MetresCubed"
            {...getOverrideProps(overrides, "EmissionUnitoption5")}
          ></option>
          <option
            children="Million dollars revenue"
            value="MillionDollarsRevenue"
            {...getOverrideProps(overrides, "EmissionUnitoption6")}
          ></option>
          <option
            children="Nights"
            value="Nights"
            {...getOverrideProps(overrides, "EmissionUnitoption7")}
          ></option>
          <option
            children="Passenger per km"
            value="PassengerPerKm"
            {...getOverrideProps(overrides, "EmissionUnitoption8")}
          ></option>
          <option
            children="Per capita"
            value="PerCapita"
            {...getOverrideProps(overrides, "EmissionUnitoption9")}
          ></option>
          <option
            children="Percentage"
            value="Percentage"
            {...getOverrideProps(overrides, "EmissionUnitoption10")}
          ></option>
          <option
            children="Quantity"
            value="Quantity"
            {...getOverrideProps(overrides, "EmissionUnitoption11")}
          ></option>
          <option
            children="Tonnes"
            value="Tonnes"
            {...getOverrideProps(overrides, "EmissionUnitoption12")}
          ></option>
          <option
            children="Tonnes per km"
            value="TonnesPerKm"
            {...getOverrideProps(overrides, "EmissionUnitoption13")}
          ></option>
        </SelectField>
        <TextField
          label="Usage (e.g. how many litres fuel consumed)"
          isRequired={false}
          isReadOnly={false}
          type="number"
          step="any"
          value={EmissionUsageValue}
          onChange={(e) => {
            let value = isNaN(parseFloat(e.target.value))
              ? e.target.value
              : parseFloat(e.target.value);
            if (onChange) {
              const modelFields = {
                EmissionScope,
                EmissionCategory,
                EmissionDescription,
                DataSource,
                EmissionDate,
                EmissionUnit,
                EmissionUsageValue: value,
                EmissionConversionFactor,
                GrossEmission,
                EmissionDateRangeStart,
                EmissionDateRangeEnd,
              };
              const result = onChange(modelFields);
              value = result?.EmissionUsageValue ?? value;
            }
            if (errors.EmissionUsageValue?.hasError) {
              runValidationTasks("EmissionUsageValue", value);
            }
            setEmissionUsageValue(value);
          }}
          onBlur={() =>
            runValidationTasks("EmissionUsageValue", EmissionUsageValue)
          }
          errorMessage={errors.EmissionUsageValue?.errorMessage}
          hasError={errors.EmissionUsageValue?.hasError}
          {...getOverrideProps(overrides, "EmissionUsageValue")}
        ></TextField>
      </Grid>
      <Grid
        columnGap="inherit"
        rowGap="inherit"
        templateColumns="repeat(2, auto)"
        {...getOverrideProps(overrides, "RowGrid7")}
      >
        <TextField
          label="Emission conversion factor"
          isRequired={false}
          isReadOnly={false}
          type="number"
          step="any"
          value={EmissionConversionFactor}
          onChange={(e) => {
            let value = isNaN(parseFloat(e.target.value))
              ? e.target.value
              : parseFloat(e.target.value);
            if (onChange) {
              const modelFields = {
                EmissionScope,
                EmissionCategory,
                EmissionDescription,
                DataSource,
                EmissionDate,
                EmissionUnit,
                EmissionUsageValue,
                EmissionConversionFactor: value,
                GrossEmission,
                EmissionDateRangeStart,
                EmissionDateRangeEnd,
              };
              const result = onChange(modelFields);
              value = result?.EmissionConversionFactor ?? value;
            }
            if (errors.EmissionConversionFactor?.hasError) {
              runValidationTasks("EmissionConversionFactor", value);
            }
            setEmissionConversionFactor(value);
          }}
          onBlur={() =>
            runValidationTasks(
              "EmissionConversionFactor",
              EmissionConversionFactor
            )
          }
          errorMessage={errors.EmissionConversionFactor?.errorMessage}
          hasError={errors.EmissionConversionFactor?.hasError}
          {...getOverrideProps(overrides, "EmissionConversionFactor")}
        ></TextField>
        <TextField
          label="Gross emission (metric tonnes CO2e)"
          isRequired={false}
          isReadOnly={false}
          type="number"
          step="any"
          value={GrossEmission}
          onChange={(e) => {
            let value = isNaN(parseFloat(e.target.value))
              ? e.target.value
              : parseFloat(e.target.value);
            if (onChange) {
              const modelFields = {
                EmissionScope,
                EmissionCategory,
                EmissionDescription,
                DataSource,
                EmissionDate,
                EmissionUnit,
                EmissionUsageValue,
                EmissionConversionFactor,
                GrossEmission: value,
                EmissionDateRangeStart,
                EmissionDateRangeEnd,
              };
              const result = onChange(modelFields);
              value = result?.GrossEmission ?? value;
            }
            if (errors.GrossEmission?.hasError) {
              runValidationTasks("GrossEmission", value);
            }
            setGrossEmission(value);
          }}
          onBlur={() => runValidationTasks("GrossEmission", GrossEmission)}
          errorMessage={errors.GrossEmission?.errorMessage}
          hasError={errors.GrossEmission?.hasError}
          {...getOverrideProps(overrides, "GrossEmission")}
        ></TextField>
      </Grid>
      <Text
        children="If your emissions occurred over a date or is estimated over a period, you can use the date range fields below."
        {...getOverrideProps(overrides, "SectionalElement3")}
      ></Text>
      <Grid
        columnGap="inherit"
        rowGap="inherit"
        templateColumns="repeat(2, auto)"
        {...getOverrideProps(overrides, "RowGrid9")}
      >
        <TextField
          label="Emission date range start"
          isRequired={false}
          isReadOnly={false}
          type="date"
          value={EmissionDateRangeStart}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                EmissionScope,
                EmissionCategory,
                EmissionDescription,
                DataSource,
                EmissionDate,
                EmissionUnit,
                EmissionUsageValue,
                EmissionConversionFactor,
                GrossEmission,
                EmissionDateRangeStart: value,
                EmissionDateRangeEnd,
              };
              const result = onChange(modelFields);
              value = result?.EmissionDateRangeStart ?? value;
            }
            if (errors.EmissionDateRangeStart?.hasError) {
              runValidationTasks("EmissionDateRangeStart", value);
            }
            setEmissionDateRangeStart(value);
          }}
          onBlur={() =>
            runValidationTasks("EmissionDateRangeStart", EmissionDateRangeStart)
          }
          errorMessage={errors.EmissionDateRangeStart?.errorMessage}
          hasError={errors.EmissionDateRangeStart?.hasError}
          {...getOverrideProps(overrides, "EmissionDateRangeStart")}
        ></TextField>
        <TextField
          label="Emission date range end"
          isRequired={false}
          isReadOnly={false}
          type="date"
          value={EmissionDateRangeEnd}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                EmissionScope,
                EmissionCategory,
                EmissionDescription,
                DataSource,
                EmissionDate,
                EmissionUnit,
                EmissionUsageValue,
                EmissionConversionFactor,
                GrossEmission,
                EmissionDateRangeStart,
                EmissionDateRangeEnd: value,
              };
              const result = onChange(modelFields);
              value = result?.EmissionDateRangeEnd ?? value;
            }
            if (errors.EmissionDateRangeEnd?.hasError) {
              runValidationTasks("EmissionDateRangeEnd", value);
            }
            setEmissionDateRangeEnd(value);
          }}
          onBlur={() =>
            runValidationTasks("EmissionDateRangeEnd", EmissionDateRangeEnd)
          }
          errorMessage={errors.EmissionDateRangeEnd?.errorMessage}
          hasError={errors.EmissionDateRangeEnd?.hasError}
          {...getOverrideProps(overrides, "EmissionDateRangeEnd")}
        ></TextField>
      </Grid>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement4")}
      ></Divider>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Reset"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          isDisabled={!(idProp || emissionAccountEntryModelProp)}
          {...getOverrideProps(overrides, "ResetButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={
              !(idProp || emissionAccountEntryModelProp) ||
              Object.values(errors).some((e) => e?.hasError)
            }
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
